import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { MedicationRequestDetailsComponent } from './medication-request-details.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { DosageAddModule } from '../../dosage/add/dosage-add.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, DosageAddModule],
  declarations: [MedicationRequestDetailsComponent],
  exports: [MedicationRequestDetailsComponent]
})
export class MedicationRequestDetailsModule { }
